import {BaseCard} from "../../Components/Cards/BaseCard";
import {faUser} from "@fortawesome/free-solid-svg-icons";
import {IconInputCard} from "../../Components/Cards/IconInputCard";
import {useBoundStore} from "../../Store/store";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {TextInput} from "../../Components/Form/TextInput";
import * as React from "react";
import Medicine from "../../Assets/images/illustrations/medicine.png";
import {useTranslation} from "react-i18next";

export const Customers = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const customers = useBoundStore((state) => state.customers)
    const getAllCustomers = useBoundStore((state) => state.getAllCustomers)
    const customerMetaData = useBoundStore((state) => state.customerMetaData)

    const [search, setSearch] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);

    useEffect(() => {
        setCurrentPage(1);
    }, [search]);

    useEffect(() => {
        setIsLoading(true);
        getAllCustomers(search,currentPage).then(() => {
            setIsLoading(false);
        })
    }, [getAllCustomers, search, currentPage])


    const goToNextPage = () => {
        if(canGoToNextPage()) {
            setCurrentPage(currentPage + 1);
        }
    }

    const goToPreviousPage = () => {
        if(canGoToPrevious()) {
            setCurrentPage(currentPage - 1);
        }
    }

    const getPageCountFromMetaData = () => {
        return customerMetaData?.last_page;
    }

    const canGoToNextPage = () => {
        return customerMetaData?.last_page > currentPage;
    };

    const canGoToPrevious = () => {
        return currentPage > 1;
    };

    return (
        <div>
            <div className={'mb-2 '}>
                <div className={'grid grid-cols-1 md:grid-cols-3'}>
                    <div className={'my-auto'}>
                        <TextInput
                            type={'text'}
                            name={'search'}
                            translationIndex={null}
                            placeholder={t('general.actions.search')}
                            onChange={(e) => setSearch(e.target.value)}
                        >
                        </TextInput>
                    </div>
                </div>
            </div>
            <BaseCard>
                {
                    !isLoading && (
                        <div>
                            <div className={'grid grid-cols-1 md:grid-cols-3 gap-4'}>
                                {
                                    customers.map((customer, index) => {
                                        return (
                                            <IconInputCard
                                                icon={faUser}
                                                isImage={true}
                                                onClick={() => {
                                                    navigate(`/admin/customers/${customer.id}`)
                                                }}
                                                otherImage={Medicine}
                                                showArrow={true}
                                                key={`customer_admin_${index}`}
                                            >
                                                <div className={'flex flex-row justify-between'}>
                                                    <div>
                                                        <p className={'text-xs text-gray-500'}>{customer.firstname} {customer.lastname}</p>
                                                        <p className={'text-xs'}>{customer.email}</p>
                                                    </div>
                                                </div>
                                            </IconInputCard>
                                        )
                                    })
                                }
                            </div>

                            <div className="flex sm:flex-row flex-col w-full mt-8 items-end justify-end gap-2 text-xs">
                                <div className="flex gap-2">
                                    <button
                                        className={`${
                                            !canGoToPrevious()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:cursor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => setCurrentPage(1)}
                                        disabled={!canGoToPrevious()}
                                    >
                                        <span className="w-5 h-5">{'<<'}</span>
                                    </button>
                                    <button
                                        className={`${
                                            !canGoToPrevious()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:curstor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => {
                                            goToPreviousPage()
                                        }}
                                        disabled={!canGoToPrevious()}
                                    >
                                        <span className="w-5 h-5">{'<'}</span>
                                    </button>
                                    <span className="flex items-center gap-1">
                            {currentPage} / {getPageCountFromMetaData()}
                        </span>
                                    <button
                                        className={`${
                                            !canGoToNextPage()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:cursor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => {
                                            goToNextPage()
                                        }}
                                        disabled={!canGoToNextPage()}
                                    >
                                        <span className="w-5 h-5">{'>'}</span>
                                    </button>
                                    <button
                                        className={`${
                                            !canGoToNextPage()
                                                ? 'bg-gray-100'
                                                : 'hover:bg-gray-200 hover:cursor-pointer bg-gray-100'
                                        } rounded p-1`}
                                        onClick={() => setCurrentPage(getPageCountFromMetaData())}
                                        disabled={!canGoToNextPage()}
                                    >
                                        <span className="w-5 h-5">{'>>'}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    isLoading && (
                        <div className="flex justify-center items-center col-span-3">
                            <div
                                className="animate-spin rounded-full mx-auto h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
                        </div>
                    )
                }
            </BaseCard>
        </div>
    )
}